"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccelerationJson = exports.Acceleration = exports.AccelerationUnitTexts = exports.AccelerationUnits = void 0;
const Quantity_1 = require("./Quantity");
const constants_1 = require("./constants");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var AccelerationUnits;
(function (AccelerationUnits) {
    AccelerationUnits["default"] = "m_s2";
    AccelerationUnits["m_s2"] = "m_s2";
    AccelerationUnits["ft_s2"] = "ft_s2";
})(AccelerationUnits = exports.AccelerationUnits || (exports.AccelerationUnits = {}));
exports.AccelerationUnitTexts = {
    [AccelerationUnits.default]: 'm/s²',
    [AccelerationUnits.m_s2]: 'm/s²',
    [AccelerationUnits.ft_s2]: 'ft/s²',
};
class Acceleration extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'Acceleration';
        this.type = this.className;
        this.defaultUnit = 'm_s2';
        this.unitTexts = exports.AccelerationUnitTexts;
    }
    static getUnitText(unit) {
        return exports.AccelerationUnitTexts[unit];
    }
    static fromJson(q) {
        if (!(0, echain_shared_ts_utils_1.isValueInEnum)(AccelerationUnits, q.Unit)) {
            throw new Error(`Acceleration.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new Acceleration(q);
    }
    static m_s2(v) {
        return new Acceleration(v, 'm_s2');
    }
    static ft_s2(v) {
        return new Acceleration(v, 'ft_s2');
    }
    set m_s2(v) {
        this.setValueUnit(v, 'm_s2');
    }
    get m_s2() {
        switch (this.unit) {
            case 'm_s2':
                return this.value;
            case 'ft_s2':
                return this.value / constants_1.FACTOR_DISTANCE;
        }
        throw new Error(`Acceleration.m_s2: unknown unit ${this.unit}`);
    }
    set ft_s2(v) {
        this.setValueUnit(v, 'ft_s2');
    }
    get ft_s2() {
        return this.unit === 'ft_s2' ? this.value : this.m_s2 * constants_1.FACTOR_DISTANCE;
    }
    clone() {
        return Acceleration.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case AccelerationUnits.m_s2:
                return this.m_s2;
            case AccelerationUnits.ft_s2:
                return this.ft_s2;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
    }
}
exports.Acceleration = Acceleration;
Acceleration.units = AccelerationUnits;
const isAccelerationJson = (l) => {
    return (0, Quantity_1.isQuantityJson)(l) && (0, echain_shared_ts_utils_1.isValueInEnum)(AccelerationUnits, l.Unit);
};
exports.isAccelerationJson = isAccelerationJson;
//# sourceMappingURL=Acceleration.js.map